<template>
  <div class="quotes-contain"  v-loading="loading">
    <bCardHeader :param="param" :buttons="buttons"/>
    <el-row class="elRow">
      <el-col v-if="!status">
        <el-row >
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
           <div class="bonds-title" test_id="personal_info">{{$t('headerCard.breadcrumb.bonds')}}</div>
           <h4>{{$t('bonds.bondsTitle')}}</h4>
           <div class="list-wrapper">
            <div class="content-word" ref="scrollbar" :style="{height: popUpViewHight}"
             v-html="$t('bonds.statementContext')">
             </div>
           </div>
            <div class="agree-check">
            <el-checkbox v-model="agreeConf.checked"
            :disabled="agreeConf.disabled"
            :size="agreeConf.size" >{{$t('bonds.bondsAgreeContext')}}</el-checkbox>
          </div>
          </el-col>
          <el-col>
             <el-button :loading="loading" type="primary" :disabled="!agreeConf.checked" @click="bondSubmit">{{$t('quotes.submitApply')}}</el-button>
          </el-col>
        </el-row>
      </el-col>
       <el-col class="bonds-success" v-if="status">
         <img src="@/assets/images/success.png" class="bonds-success-img" />
          <h1 class="bonds-success-title">{{$t('bonds.successMessage')}}</h1>
          <div class="bonds-tips">{{$t('bonds.successTips')}}</div>
          </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['getAccountInfo', 'getClientProfile']),
    popUpViewHight () {
      return document.documentElement.clientHeight * 0.55 + 'px'
    }
  },

  data () {
    return {
      status: false,
      loading: true,
      buttons: [],
      agreeConf: {
        size: 'md',
        disabled: true,
        checked: false
      },
      param: {
        title: 'bonds',
        links: [{ title: 'home' }, { title: 'my_account' }, { title: 'bonds' }]
      }
    }
  },
  async mounted () {
    this.bondsInit()
    window.addEventListener('scroll', this.listenScrollbar, true)
  },
  destroyed () {
    //  删除监听事件
    window.removeEventListener('scroll', this.listenScrollbar, true)
  },
  methods: {
    // 监听scrollbar滚动事件
    listenScrollbar () {
      if (!this.agreeConf.disabled) return
      let scrollTop = this.$refs['scrollbar'].scrollTop // 滚动条滚动距离
      let scrollTopMax = this.$refs['scrollbar'].scrollTopMax // 浏览器总高度
      let scrollheight = this.$refs['scrollbar'].scrollHeight
      let clientHeight = this.$refs['scrollbar'].clientHeight
      if (parseInt(scrollTop + clientHeight + 10) >= parseInt(scrollheight) || parseInt(scrollTop) >= parseInt(scrollTopMax)) { Object.assign(this.agreeConf, { disabled: false }) }
    },
    async bondsInit () {
      const result = await this.$api.getBonds({
        clientId: this.getAccountInfo.clientId
      })
      this.status = result.data.isOpenBonds
      this.loading = false
    },
    getLanguage () {
      let languageM = this.Util.getCookie('language') ? this.Util.getCookie('language') : 'cn'
      let curLang = ''
      switch (languageM) {
        case 'en':
          curLang = 'en'
          break
        case 'zh-hant':
          curLang = 'hk'
          break
        case 'zh-hans':
          curLang = 'cn'
          break
        default:
          curLang = 'cn'
          break
      }
      return curLang
    },
    async bondSubmit () {
      if (this.loading) return
      this.loading = true
      if (!this.agreeConf.checked) {
        this.loading = false
        return this.$message.error(this.$t('bonds.errorMessage.20100'))
      }
      let data = this.getAccountInfo.tradeAccountList
      const res = data.some(
        account =>
          account.enabled === 'open' && (account.tradeAccountType === 'securitiesCash' ||
          account.tradeAccountType === 'securitiesMargin')
      )// 这里判断是否存在现金或者保证金的账号并且处于开启状态
      if (!res) {
        this.loading = false
        return this.$message.error(this.$t('bonds.errorMessage.20104'))
      }
      const result = await this.$api
        .bondSubmit({
          emailTo: this.getClientProfile.userInfo.email,
          language: this.getLanguage(),
          clientId: this.getClientProfile.userInfo._id,
          isAgress: this.agreeConf.checked,
          applySource: 'CP'
        })
        .catch(error => {
          this.$message.error(this.$t(`bonds.errorMessage.${error.code}`))
          this.loading = false
        })
      if (!result) {
        this.loading = false
        return
      }
      this.status = true
      this.loading = false
    }
  }
}
</script>
<style lang="scss" scoped>
.bonds-title {
  height: 30px;
  line-height: 30px;
  font-size: 20px;
  font-weight: bold;
  color: #24282d;
  border-bottom: 4px solid #e2e2e2;
  padding-bottom: 20px;
}

.elRow {
  padding: 30px;
  min-height: 683px;
  background: #fff;
  .bonds-success {
    color: #24282d;
    text-align: center;
    .bonds-success-img {
      margin-top: 160px;
    }
    .bonds-success-title {
      font-size: 22px;
    }
    .bonds-tips {
      font-size: 14px;
    }
  }

  /deep/ .el-button {
    width: 250px;
    height: 60px;
    font-size: 16px;
  }
}
.list-wrapper {
  .content-word {
    // border-left: 4px solid #fec000;
    background: #f3f4f6;
    padding: 0px 0px 20px 20px;
    color: #666666;
    overflow-y: scroll;
  }
  h5 {
    padding: 0 !important;
    margin: 0 !important;
  }
  /deep/ .el-checkbox__inner {
    width: 20px;
    height: 20px;
  }
  /deep/ .el-checkbox__label {
    font-size: 14px !important;
  }
  .terms-content {
    margin-bottom: 15px;
    overflow-y: scroll;
  }
  .terms {
    overflow-y: scroll;
    .title {
      font-weight: bold;
    }
    .sub-title {
      font-weight: bold;
    }
  }
}
.agree-check {
  color: rgba(85, 85, 85, 1);
  font-size: 30px;
  text-align: left;
  font-family: PingFangSC-Regular;
  margin: 20px 0;
  /deep/ .el-checkbox {
    white-space: break-spaces;
  }
  /deep/ .el-checkbox__input {
    vertical-align: top;
  }
  /deep/ .el-checkbox__label {
    width: 88%;
    padding-left: 10px !important;
    font-size: 15px !important;
    color: #666666;
  }
  /deep/ .el-checkbox__inner::after {
    height: 12px;
    left: 8px;
    top: 3px;
    width: 3px;
  }
  /deep/ .el-checkbox__inner {
    width: 22px;
    height: 22px;
  }
}
</style>
